module.exports = __webpack_public_path__ + "img/roles.9bbc1b9a.svg";